var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-analysis-mask",on:{"click":_vm.clossPaperAnalysis}},[_c('FullTxtArtAnalysisResultWorkBench',{staticStyle:{"max-width":"60vw"},attrs:{"full_txt_art_analysis_data":_vm.full_txt_art_analysis_data},on:{"clossPaperAnalysis":_vm.clossPaperAnalysis}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }